/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP 기기등록현황 - tab 개발
 *
 ********************************************************************/
import React from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../recoil/menuState';
import DeciveStatusTab from "./devicelist/DeciveStatusTab";
/**
* @brief EHP 기기등록현황 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function DeciveStatusMain(props) {
    //recoil
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const setPopWin = props.setPopWin;
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container admin-site", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""} ` },
                    React.createElement(DeciveStatusTab, { setPopWin: setPopWin }))))));
}
export default DeciveStatusMain;
